module.exports = __webpack_public_path__ + "img/Medical practitioners.1e0474b3.png";